import { render, staticRenderFns } from "./bin-rounded.vue?vue&type=template&id=3f0381e8"
import script from "./bin-rounded.vue?vue&type=script&lang=js"
export * from "./bin-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports